import * as Sentry from '@sentry/react'
import packageJson from '../../package.json'
import { scrubTickets } from './sentry-scrub'

const isDEV = import.meta.env.DEV
const packageVersion = packageJson.version

if (!(import.meta.env.DEV && ['true', '1'].includes(import.meta.env.VITE_USE_MOCKS ?? ''))) {
  Sentry.init({
    dsn: 'https://0bfab4b9b96ba7d47eddcf966fdfe57e@o4508469266677760.ingest.us.sentry.io/4509911807492096',
    environment: import.meta.env.VITE_APP_ENVIRONMENT || 'local',
    release: `netprism-dashboard-agent@${packageVersion}`,
    sendDefaultPii: true,
    enableLogs: true,
    tracesSampleRate: 0,
    replaysSessionSampleRate: isDEV ? 1 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeBreadcrumb: breadcrumb => scrubTickets(breadcrumb),
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        beforeAddRecordingEvent: event => scrubTickets(event),
      }),
      // An event processor rather than beforeSend: replay events skip beforeSend.
      {
        name: 'ScrubConnectTickets',
        processEvent: event => scrubTickets(event),
      },
    ],
  })
}
